import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box } from "@mui/material";

export default function FormDialog({
  widthProp = 0.8,
  children,
  title = "",
  description = "",
  handleClose,
  open,
  postiveButtonText = "Save",
  negativeButtonText = "Cancel",
  negativeButtonCallback = handleClose,
  postiveButtonCallback = handleClose,
}) {
  return (
    <Dialog
      PaperProps={{
        sx: {
          width: { xs: "92%", sm: "auto" },
          minWidth: { xs: "auto", sm: 380 },
          maxWidth: 480,
          borderRadius: 3,
          overflow: "hidden",
        },
      }}
      open={open}
      onClose={handleClose}
    >
      {title && (
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #1a237e 0%, #283593 100%)",
            color: "#fff",
            fontWeight: 700,
          }}
        >
          {title}
        </DialogTitle>
      )}
      <DialogContent sx={{ pt: title ? 3 : 2 }}>
        {description && (
          <DialogContentText sx={{ mb: 2 }}>{description}</DialogContentText>
        )}
        <Box sx={{ mt: 1 }}>{children}</Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={negativeButtonCallback}>
          {negativeButtonText}
        </Button>
        <Button
          variant="contained"
          onClick={postiveButtonCallback}
          sx={{
            background: "linear-gradient(135deg, #1a237e 0%, #283593 100%)",
          }}
        >
          {postiveButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
